import { render, staticRenderFns } from "./LookupTables.vue?vue&type=template&id=6580d6f4&scoped=true"
import script from "./LookupTables.vue?vue&type=script&lang=js"
export * from "./LookupTables.vue?vue&type=script&lang=js"
import style0 from "./LookupTables.vue?vue&type=style&index=0&id=6580d6f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6580d6f4",
  null
  
)

export default component.exports